import React from 'react';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import { useTheme, Colorway } from '@uds/theme-utils';

import useStylesheet from './ItemFeature.stylesheet';

export type FeatureProps = {
  text: ShortcodeProps | string;
};

interface OuterProps {
  feature: FeatureProps;
  first?: boolean;
  last?: boolean;
}

const PureSalesboardItemFeature = ({ feature, first, last }: OuterProps) => {
  const { theme } = useTheme();
  const { styles } = useStylesheet({
    theme,
    first,
    last,
  });
  return (
    <li style={styles.root}>
      <Shortcode code={feature.text} against={Colorway.LIGHT} />
    </li>
  );
};

PureSalesboardItemFeature.displayName = 'SalesboardItemFeature';

export default PureSalesboardItemFeature;
